// outline blue button

import React from "react";

export default function OutlineBlueBtn2({ children, onClick, className }) {
  return (
    <button className={className + " outline-blue-btn2 "} onClick={onClick}>
      {children}
    </button>
  );
}
